import { Link } from "easy-page-router/react";
import Icon from "@mdi/react";
import { mdiArrowRightThin } from "@mdi/js";

import { useUser } from "../User";
import Sponsors from "./Sponsors";

export default function Footer() {
    const { user, setUser } = useUser();

    return <footer>
        <div className="content">
            <Sponsors />
            <div className="columns">
                <div>
                    <h5>
                        Krkonoše <span className="br" />technický svazek obcí
                    </h5>
                    <p>
                        Masarykovo náměstí 82 <br />
                        514 01 Jilemnice
                    </p>
                    <h5>
                        kancelář v budově <span className="br" />Společenského domu Jilm
                    </h5>
                    <p>
                        Roztocká 500 <br />
                        514 01 Jilemnice
                    </p>
                </div>
                <div>
                    <Link to="/">Aktuality</Link>
                    <Link to="/o-nas">O nás</Link>
                    <Link to="/uredni-deska">Úřední deska</Link>
                    <Link to="/verejne-dokumenty">Veřejné dokumenty</Link>
                    <Link to="/projekty">Projekty</Link>
                    <Link to="/o-nas/kontakty">Kontakt</Link>
                </div>
                <div>
                    {!user && <>
                        <h5>Starosta</h5>
                        <Link to="/starosta">→ Přihlášení</Link>
                        <h5 style={{ paddingTop: "16px" }}>Administrace</h5>
                        <Link to="/starosta">→ Přihlášení</Link>
                    </>}
                    {user && (
                        <>
                            <h5>{user.name}</h5>
                            <Link to="/starosta">
                                <Icon
                                    path={mdiArrowRightThin}
                                    size={1}
                                />{" "}
                                {user.roles.includes("admin") ? "Administrace" : "Starosta"}
                            </Link>
                            <a onClick={() => setUser(null)}>
                                <Icon
                                    path={mdiArrowRightThin}
                                    size={1}
                                />{" "}
                                Odhlásit se
                            </a>
                        </>
                    )}
                </div>
            </div>
        </div>
        <div className="copyright">
            <Link to="/">© 2024 TSO Krkonoše</Link>{" "}
            Všechna práva vyhrazena
            <span className="left">
                Design: <a href="https://www.graphto.art/" target="__blank"><b>graph</b>to</a>
            </span>
            <span className="right">
                Vytvořil: <a href="https://paulu.cz/" target="__blank"><b>Filip</b></a>
            </span>
        </div>
    </footer>;
}